const HelpDeskIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_21068_125091)">
        <path
          d="M13.2919 5.33329H13.9998C14.7362 5.33329 15.3332 5.93025 15.3332 6.66663V9.33329C15.3332 10.0697 14.7362 10.6666 13.9998 10.6666H13.2919C12.9638 13.2975 10.7196 15.3333 7.99984 15.3333V14C10.209 14 11.9998 12.2091 11.9998 9.99996V5.99996C11.9998 3.79082 10.209 1.99996 7.99984 1.99996C5.7907 1.99996 3.99984 3.79082 3.99984 5.99996V10.6666H1.99984C1.26346 10.6666 0.666504 10.0697 0.666504 9.33329V6.66663C0.666504 5.93025 1.26346 5.33329 1.99984 5.33329H2.70776C3.03583 2.70242 5.28009 0.666626 7.99984 0.666626C10.7196 0.666626 12.9638 2.70242 13.2919 5.33329ZM1.99984 6.66663V9.33329H2.6665V6.66663H1.99984ZM13.3332 6.66663V9.33329H13.9998V6.66663H13.3332ZM5.1728 10.5232L5.87956 9.39243C6.49424 9.77743 7.22104 9.99996 7.99984 9.99996C8.77864 9.99996 9.50544 9.77743 10.1201 9.39243L10.8269 10.5232C10.0073 11.0366 9.03824 11.3333 7.99984 11.3333C6.96144 11.3333 5.99238 11.0366 5.1728 10.5232Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_21068_125091">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HelpDeskIcon;
